import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ProjectDetails from './components/ProjectDetails';
import Main from './layout/Main';
import Blogs from './pages/Blogs';
import Home from './pages/Home';
import ParticlesBg from 'particles-bg';
import BIRDS from 'vanta/dist/vanta.net.min.js'
import { useEffect, useRef, useState } from 'react';
import { VANTA } from 'vanta';




const route = createBrowserRouter([
  {
    path: '/',
    element: <Main></Main>,
    children: [
      {
        path: '/',
        element: <Home></Home>
      },
      {
        path: '/blogs',
        element: <Blogs></Blogs>
      }
      ,
      {
        path: '/projects/:id',
        element: <ProjectDetails></ProjectDetails>,
        loader: ({ params }) => fetch(`https://portfolio-server-murex.vercel.app/projects/${params.id}`)
      }
    ]
  }
])

function App() {


  return (
    <div >
      <RouterProvider router={route}></RouterProvider>
      {/* <ParticlesBg type="polygon" bg={true} /> */}
    </div>
  );
}

export default App;
